<template>
	<div>
	  <SubTopNav :title="title" :image="image" />
	  <div class="people content">

		<div>
			<div v-html="content"></div>
			<div class="person-grid">
				<div v-for="(person, index) in people.slice().reverse()" :key="index" class="person" :id="'person-'+person.nid[0].value">
					<div class="clickbox"  @click="loadProfile(person)">
						<h2 style="">{{ person.title[0].value }} <i class="fas fa-angle-double-right" style="font-size:12pt" v-show="currentPerson != person.nid[0].value"></i><i class="fas fa-angle-double-down" style="font-size:12pt" v-show="currentPerson == person.nid[0].value"></i></h2>
						<h3><div class="position">{{ person.field_displaytitle[0].value }}</div></h3>
					</div>
					<div v-show="currentPerson == person.nid[0].value" class="person-body animated fadeIn">
						<div class="profile-pic" v-if="person.field_profile_picture && person.field_profile_picture.length > 0"><img :src="person.field_profile_picture[0].url"></div>
						<div v-html="person.body[0].value"></div>
					</div>
				</div>
			</div>
		</div>  		
	  </div>
	  
	
  </div>
</template>
<script>
// @ is an alias to /src
	import SubTopNav from "@/components/SubTopNav.vue";
	import { RepositoryFactory } from "@/repositories/RepositoryFactory"
  const ContentRepository = RepositoryFactory.get("content");

	export default {
	  name: "people",
	  components: {
	    SubTopNav
	  },
	  data: function(){
	  	return {
	  		content: null,
	  		image: null,
	  		currentPerson:null,
	  		people: [],
	  		title:null
	  	}
	  },
	  methods: {
	  	async getPeoplePage(){
	  		var type = "page"
	        var id = "22"
	        const { data } = await ContentRepository.get(type, id)

	        if (data.length > 0){
	          if (data[0].body.length > 0){
        		this.content = data[0].body[0].value
        	  }

        	  if (data[0].title[0].value){
        	  	this.title = data[0].title[0].value
        	  }
	          if (data[0].field_page_header_image.length > 0){
	          	this.image = data[0].field_page_header_image[0].url
	          }
	          
	        }
	  		},
	  		async getPeople(){
		  		var type = "person"
		        var id = "all"
		        const { data } = await ContentRepository.get(type, id)
		        console.log('people', data)

		        if (data.length > 0){
		          
		          
		          data.sort(function (a, b) {
		          	var nameA = a.title[0].value.toUpperCase(); // ignore upper and lowercase
  					var nameB = b.title[0].value.toUpperCase();
		          	if (nameA < nameB) {
					    return 1;
					  }
					  if (nameA > nameB) {
					    return -1;
					  }

					  // names must be equal
					  return 0;
		          })

		          this.people = data

		          var alias = this.$route.hash

		          if (alias){
		          	alias = alias.replace('#', '/')
		          	var itemArray = this.people.filter(item => {
		          	 	return (alias == item.path[0].alias)
		          	})

		          	if (itemArray.length > 0){
		          		var loadItem = itemArray[0]
		          		this.loadProfile(loadItem)
		          	}
		          }

		        }
	  		},
	  		loadProfile(person){

	  			var personId = '#person-'+person.nid[0].value
	  			

	  			if (this.currentPerson == person.nid[0].value){
	  				var path = this.$route.path
		  			history.pushState(
					    {},
					    null,
					    path
					)
	  				this.currentPerson = null
	  			} else {
	  				var alias = person.path[0].alias.replace('/', '#')
		  			history.pushState(
					    {},
					    null,
					    this.$route.path + alias
					)
	  				this.currentPerson = person.nid[0].value
	  			}

	  			setTimeout(function () { 
	  				this.$scrollTo(personId, 500, {xoffset: -300})
	  			}.bind(this), 200)
	  			
	  			
	  			
	  			// console.log('nid', person.nid[0].value)
	  			// window.scrollTo(0,0);

	  		}
	  },
	  mounted(){
	  	this.getPeoplePage()
	  	this.getPeople()
	  }
	};
</script>
<style scoped>
	.people{
		text-align:left;
		margin-left:5%;
	}

	.profile-pic{
		padding-left:25px;
		xfloat:left;
		xmargin-right:25px;
		xmargin-bottom:25px;
		xwidth:300px;
	}

	.profile-pic img{
		max-width:100%;
	}

	.clickbox{
		padding:30px 0px 30px 30px;
		cursor:pointer;
	}

	.left-column{
		margin-bottom:25px;
	}

	.person{
		/*width:150px;
		height:150px;*/
		
		text-transform:uppercase;
		font-weight:bold;
		xcolor:#FFF;
		xbackground:#999;
		border-left:2px solid #333;
		border-bottom:2px solid #333;
		min-height:125px;
		margin-bottom:25px;
		/*display:inline-block;*/
	}

	.person h2{
		font-size:20px;
		font-weight:bold;
	}

	.person-body{
		text-transform:none;
		xfont-size:15px !important;
		font-weight:normal;
		position:relative;
		z-index:1;
		display:grid;
		grid-template-columns: 350px 1fr;
		grid-gap:25px;
	}

	.current-person{
		background:rgba(255, 255, 255, 0.95);
		position:absolute;
		/*width:100%;
		height:100vh;*/
		top:0;
		left:0;
		right:0;
		bottom:0;
		height:100vh;
		padding:50px;
		text-align:left;
		z-index:500;
	}

	.close-icon{
		float:right;
		cursor:pointer;
		margin-right:-25px;
		margin-top:-25px;
	}

	.person:hover{
		xbackground:#FFFF00;
	}

	.position{
		font-family:"Tahoma", "Avenir", Helvetica, Arial, sans-serif;
		font-size:60%;
		font-weight:normal;
	}

	.person-grid{
		xdisplay:grid;
		xgrid-template-columns: 1fr 1fr;
		grid-gap:25px;
	}

	.page-image img{
		max-width:100%;
	}

	.page-image{
		background-size:cover;
	}

	.square{
		width:50%;
		overflow:hidden;
	}

	.square.blue{
		xclear:both;
		float:left;
		background:rgba(0,102,255,0.8);
	}

	.square.green{
		background:rgba(0,153,51,0.8);
		float:right;
	}

	.square.yellow{
		background:rgba(255,255,0,0.8);
		clear:both;
		margin-bottom:20px;
	}

	.square:after {
	  content: "";
	  display: block;
	  padding-bottom: 100%;
	}

	@media (max-width:768px){
		.profile-pic{
			width:100%;
		}

		.person-body {
			grid-template-columns: 1fr;
		}

		.person-body div:nth-child(2){
			margin-left:25px;
		}
	}


</style>
